import type { StatusPagePayload } from '@/types';

const REQUEST_TIMEOUT_MS = 10_000;

export const getStatusPage = async (
  url: string,
): Promise<StatusPagePayload> => {
  const response = await fetch(url, {
    cache: 'no-store',
    credentials: 'omit',
    referrerPolicy: 'no-referrer',
    signal: AbortSignal.timeout(REQUEST_TIMEOUT_MS),
  });

  if (!response.ok) {
    throw new Error(`Status page responded with ${response.status}`);
  }

  return response.json();
};
